import { Radio, Select, Tooltip, Form } from 'antd';
import { useEffect } from 'react';
import { InfoIcon, WarningOrgIcon } from 'src/icons';

export const AddNotificationTimes = ({
  handleSubmit,
  notificationStartHour,
  setNotificationStartHour,
  notificationStartMinute,
  setNotificationStartMinute,
  notificationEndHour,
  setNotificationEndHour,
  notificationEndMinute,
  setNotificationEndMinute,
  notificationStartRadio,
  setNotificationStartRadio,
  notificationEndRadio,
  setNotificationsEndRadio,
  submitWithoutNotification,
  form,
}) => {
  const isMobile = window.innerWidth < 1260;
  useEffect(() => {
    if (
      notificationStartHour &&
      notificationStartMinute &&
      notificationEndHour &&
      notificationEndMinute &&
      notificationStartRadio &&
      notificationEndRadio
    ) {
      form.setFieldsValue({
        notificationStartHour,
        notificationStartMinute,
        notificationEndHour,
        notificationEndMinute,
        notificationStartRadio,
        notificationEndRadio,
      });
    }
  }, [
    notificationStartHour,
    notificationStartMinute,
    notificationEndHour,
    notificationEndMinute,
    notificationStartRadio,
    notificationEndRadio,
    form,
  ]);

  const notification_startTime_options = [
    { title: '7', value: '7' },
    { title: '8', value: '8' },
    { title: '9', value: '9' },
    { title: '10', value: '10' },
    { title: '11', value: '11' },
    { title: '12', value: '12' },
    { title: '1', value: '1' },
    { title: '2', value: '2' },
    { title: '3', value: '3' },
    { title: '4', value: '4' },
    { title: '5', value: '5' },
    { title: '6', value: '6' },
  ];

  const notification_startTime_minute_options = [
    { title: '00', value: '00' },
    { title: '05', value: '05' },
    { title: '10', value: '10' },
    { title: '15', value: '15' },
    { title: '20', value: '20' },
    { title: '25', value: '25' },
    { title: '30', value: '30' },
    { title: '35', value: '35' },
    { title: '40', value: '40' },
    { title: '45', value: '45' },
    { title: '50', value: '50' },
    { title: '55', value: '55' },
  ];

  const notification_endTime_options = [
    { title: '7', value: '7' },
    { title: '8', value: '8' },
    { title: '9', value: '9' },
    { title: '10', value: '10' },
    { title: '11', value: '11' },
    { title: '12', value: '12' },
    { title: '1', value: '1' },
    { title: '2', value: '2' },
    { title: '3', value: '3' },
    { title: '4', value: '4' },
    { title: '5', value: '5' },
    { title: '6', value: '6' },
  ];

  const notification_endTime_minute_options = [
    { title: '00', value: '00' },
    { title: '05', value: '05' },
    { title: '10', value: '10' },
    { title: '15', value: '15' },
    { title: '20', value: '20' },
    { title: '25', value: '25' },
    { title: '30', value: '30' },
    { title: '35', value: '35' },
    { title: '40', value: '40' },
    { title: '45', value: '45' },
    { title: '50', value: '50' },
    { title: '55', value: '55' },
  ];

  const startTimeAmpmOptions = [
    { label: 'AM', value: 1 },
    { label: 'PM', value: 2 },
  ];

  const endTimeAmpmOptions = [
    { label: 'AM', value: 1 },
    { label: 'PM', value: 2 },
  ];

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{}}
      autoComplete="off"
      form={form}
    >
      <div
        className={`${isMobile ? 'mb-2' : ''} bg-white p-4 rounded-2xl mt-4`}
      >
        <div className="flex items-center">
          <div className="mt-2 ml-1 mr-2 text-lg font-semibold text-[#000]">
            Patient notifications window
          </div>
          <div className="mt-2">
            <Tooltip
              title="Patient notifications are required"
              placement="right"
            >
              <div>
                {submitWithoutNotification &&
                  (!notificationStartHour ||
                    !notificationStartMinute ||
                    !notificationEndHour ||
                    !notificationEndMinute ||
                    !notificationStartRadio ||
                    !notificationEndRadio) && <WarningOrgIcon />}
              </div>
            </Tooltip>
          </div>
        </div>
        <div className="inline-block">
          <div className="flex items-center bg-[#e6f4ff] rounded-lg border border-[#91caff] pr-2 mt-1">
            <div className="mt-2 ml-2">
              <InfoIcon />
            </div>
            <div className="text-[#000] mt-0.5">
              Patients receive scheduled notifications only in this duration
            </div>
          </div>
        </div>

        <div className="gap-3 flex mt-5">
          <div className="flex mt-3 text-[#000] font-medium">
            Notification Start time
          </div>
          <div className="w-[150px]">
            <Form.Item
              name="notificationStartHour"
              rules={[{ required: true, message: 'Start hour is required' }]}
            >
              <Select
                className="bg-white p-1 outline-1 outline-[#E5E8EB] outline-none font-sans h-12 flex items-center focus:outline-none rounded-xl mb-1"
                placeholder="Hour"
                bordered={false}
                showSearch
                value={
                  notificationStartHour
                    ? notificationStartHour.toString()
                    : null
                }
                options={notification_startTime_options}
                onChange={(e) => setNotificationStartHour(e)}
              />
            </Form.Item>
          </div>

          <div className="w-[150px]">
            <Form.Item
              name="notificationStartMinute"
              rules={[{ required: true, message: 'Start min is required' }]}
            >
              <Select
                className="bg-white p-1 outline-1 outline-[#E5E8EB] outline-none font-sans h-12 flex items-center focus:outline-none rounded-xl mb-1"
                placeholder="Min"
                bordered={false}
                showSearch
                value={notificationStartMinute ? notificationStartMinute : null}
                options={notification_startTime_minute_options}
                onChange={(e) => setNotificationStartMinute(e)}
              />
            </Form.Item>
          </div>
          <div className="flex items-center">
            <Form.Item
              name="notificationStartRadio"
              rules={[{ required: true, message: 'AM/PM is required' }]}
            >
              <Radio.Group
                options={startTimeAmpmOptions}
                onChange={(e) => setNotificationStartRadio(e.target.value)}
                value={notificationStartRadio}
                defaultValue={null}
              />
            </Form.Item>
          </div>
        </div>

        <div className="gap-3 mt-5 flex">
          <div className="flex mt-3 mr-2 text-[#000] font-medium">
            Notification End time
          </div>
          <div className="w-[150px]">
            <Form.Item
              name="notificationEndHour"
              rules={[{ required: true, message: 'End hour is required' }]}
            >
              <Select
                className="bg-white p-1 outline-1 outline-[#E5E8EB] outline-none font-sans h-12 flex items-center focus:outline-none rounded-xl mb-1"
                bordered={false}
                showSearch
                value={
                  notificationEndHour ? notificationEndHour.toString() : null
                }
                placeholder="Hour"
                options={notification_endTime_options}
                onChange={(e) => setNotificationEndHour(e)}
              />
            </Form.Item>
          </div>

          <div className={isMobile ? 'w-2/6' : 'w-[150px]'}>
            <Form.Item
              name="notificationEndMinute"
              rules={[{ required: true, message: 'End min is required' }]}
            >
              <Select
                className="bg-white p-1 outline-1 outline-[#E5E8EB] outline-none font-sans h-12 flex items-center focus:outline-none rounded-xl mb-1"
                placeholder="Min"
                bordered={false}
                showSearch
                value={notificationEndMinute ? notificationEndMinute : null}
                options={notification_endTime_minute_options}
                onChange={(e) => setNotificationEndMinute(e)}
              />
            </Form.Item>
          </div>
          <div className="flex items-center">
            <Form.Item
              name="notificationEndRadio"
              rules={[{ required: true, message: 'AM/PM is required' }]}
            >
              <Radio.Group
                options={endTimeAmpmOptions}
                onChange={(e) => setNotificationsEndRadio(e.target.value)}
                value={notificationEndRadio}
                defaultValue={null}
              />
            </Form.Item>
          </div>
        </div>
      </div>
    </Form>
  );
};
